performance.mark('start_load_main');

import Form from './core/Form';
import Cart from "./core/Cart";
import * as helpers from './core/Functions';

require('es6-promise').polyfill();

Lang.setLocale(siteLang);

// https://github.com/davidchambers/string-format
let format = require('string-format');
format.extend(String.prototype, {});

window.helpers = helpers;
window.Form = Form;

// глобальный объект для корзины
window.cart = new Cart();

// глобальный объект для модалок
window.modal = {
    type: '',
};

require('./snippets/slider');
require('./snippets/prices');
require('./snippets/common');
require('./snippets/callback');
require('./snippets/auth');
require('./snippets/order');
require('./snippets/share_buttons');
require('./connect-comment');

//lazy image load
import Blazy from 'blazy';

window.Blazy = Blazy;

setTimeout(function () {
    new Blazy({
        breakpoints: [{
            width: 420,
            src: 'data-src-small'
        }]
    });
}, 500);

performance.mark('main_loaded');

//slick reviews
$('.slick-partner').slick({
    // the magic
    responsive: [{
        breakpoint: 720,
        settings: {
            slidesToShow: 2,
            infinite: true
        }
    }]
});
let palette = {
    main: '#0001fc',
    secondary: '#f2b004',
    background: 'white',
    buttonColor: "",//if null use main
    buttonHoverColor: "",//if null use light main
    buttonDisabledColor: "",//if null use #d8d8d8
    inputActiveColor: "",//if null use #FFA203
    inputErrorColor: "",//if null use secondary
    inputSuccessColor: "",//if null use secondary
    inputBorderColor: "",//if null use #d8d8d8
    inputHintLabelColor: ""//if null use main
};
let productCode = "covid19E_Artmediuz";
let options = {
    locale: siteLang === 'ua' ? 'uk' : siteLang,
    palette: palette,
    successPaymentUrl: "!Полный путь к ресурсу",
    errorPaymentUrl: "!Полный путь к ресурсу",
    createOrderSuccess: function (orderNumber, needManagerConfirmation) {
        /** Действия при успешном создании заказа */
        IO.Auth.check({
            success: () => {/** Действия для залогиненого пользователя (переход на корзину) */
            },
            fail: () => {/** Действия для незалогиненого пользователя (переход на страницу где не требуется авторизация)*/
            },
        });
    },

    createOrderError: function (error) { /** Действия при ошибке создания заказа */
    },
    createContractSuccess: function (contractId) { /** Действия при успешном заключении договора */
    },
    createContractError: function (error) { /** Действия при ошибке заключении договора */
    },
    captchaSiteKey: "6Lc9oAcUAAAAAHNtIZVgdA5MorIFAuDzlYhwD5sT",
    getContractDocumentInBytesByNumber: function (contractNumber) { /** Действия при скачивании документа*/
    },
    authSuccess: function () {
    }
};
var element = document.getElementById("bodyContainer");
IO.Widgets.makeOrder(productCode, element, options);
import {
    Select
} from 'element-ui';

Vue.component(Select.name, Select);


// WEBPACK FOOTER //
// ./resources/assets/js/main.js